import {LineupStackCombinationsMapInterface} from 'components/organisms/correlation-stacking/interfaces/lineup-stack-combinations-map.interface';

export const createComboUnitId = function (playerIds: string[], isUniversal: boolean): string {
    return playerIds.sort().join('-') + '-' + Number(isUniversal);
};

export function createLineupCorrelationStackCombinationsMap(comboGroups) {
    const map: LineupStackCombinationsMapInterface = {
        lineups: {},
        combinations: {},
    };

    comboGroups.map((group) => {
        group.sortedCombos.map((combo) => {
            const combinationId = combo.getUnitId();

            !(combinationId in map.combinations) && (map.combinations[combinationId] = {});

            combo.getLineupIds().map((lineupId) => {
                !(lineupId in map.lineups) && (map.lineups[lineupId] = {});
                map.lineups[lineupId][combinationId] = true;
                map.combinations[combinationId][lineupId] = true;
            });
        });
    });

    return map;
}
